class SupportItem {
    constructor($el) {
        this.$el = $el;

        if(this.$el.length) {
            this.init();
        }
    }

    init() {
        this.$quantityInput = this.$el.find('.support-item__quantity-input');
        this.$validationButton = this.$el.find('.support-item__validation-button');
        this.$title = this.$el.find('.support-item__heading');
        this.$quantityDescription = this.$el.find('.support-item__quantity_description');
        this.$details = this.$el.find('.support-item__details');
        this.$image = this.$el.find('.support-item__image');

        this.id = -1;
        this.title = '';
        this.details = '';
        this.image = '';
        this.quantityDescription = '';
        this.maxValue = -1;
        this.isValid = true;

        if(this.$quantityInput.length && this.$validationButton.length && this.$title.length && this.$quantityDescription.length && this.$details.length) {
            this._updateId();
            this._updateTitle();
            this._updateMaxValue();
            this._updateDetails();
            this._updateImage();
            this._updateQuantityDescription();

            if(this.maxValue !== -1) {
                this._bindEvents();
            }
        }
    }

    _bindEvents() {
        this.validateFn = this.validate.bind(this);

        this.$quantityInput.on('change', this.validateFn);
        this.$quantityInput.on('keyup', this.validateFn);
        this.$validationButton.on('click', this.validateFn);
    }

    _updateId() {
        if(this.$el[0].hasAttribute('data-support-id')) {
            this.id = parseInt(this.$el.attr('data-support-id'), 10);
        }
    }

    _updateTitle() {
        if(this.$title.length) {
            this.title = this.$title.html();
        }
    }

    _updateDetails() {
        if(this.$details.length) {
            this.details = this.$details.html();
        }
    }

    _updateImage() {
        if(this.$image.length) {
            this.image = this.$image.attr('src');
        }
    }

    _updateMaxValue() {
        if(this.$quantityInput.length) {
            if(this.$quantityInput[0].hasAttribute('max')) {
                this.maxValue = parseInt(this.$quantityInput.attr('max'), 10);

                if(isNaN(this.maxValue) || this.maxValue < 0) {
                    this.maxValue = -1;
                }
            }
        }
    }

    _updateQuantityDescription() {
        if(this.$quantityDescription.length) {
            this.quantityDescription = this.$quantityDescription.html();
        }
    }

    getValue() {
        const inputVal = parseInt(this.$quantityInput.val(), 10);

        if(isNaN(inputVal) || inputVal < 0 || inputVal > this.maxValue) {
            return 0;
        }

        return inputVal;
    }

    validate(e) {
        if(e) {
            e.preventDefault();
        }

        const inputVal = parseInt(this.$quantityInput.val(), 10);

        if(isNaN(inputVal) || inputVal < 0 || inputVal > this.maxValue) {
            this.$quantityInput.val(0);
            this.isValid = false;
        }
        else {
            if(e && e.type === 'click') {
                this.$validationButton.off('click', this.validateFn);
                this.$validationButton.attr('disabled', 'disabled');
                this.$quantityInput.attr('readonly', 'readonly');
            }
        }
    }
}

export default SupportItem;
